module.exports = __webpack_public_path__ + "static/media/17.a4a54b4e.mp3";